/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import {
  Button,
  Container,
  Divider,
  Header,
  Transition,
} from "semantic-ui-react";
import AdminCrudButtons from "../../components/Small/AdminCrudButtons";
import Loader from "../../components/Small/Loader";
import ProductItem from "../../components/Small/ProductItem";
import ProductsFilteringMenu from "../../components/Small/ProductsFilteringMenu";
import useCategoriesTree from "../../hooks/useCategoriesTree";
import { renderCategoryIcon } from "../../datas/categoryIcons";
import { $SERVER } from "../../_const/_const";
import "./categories.css";
const Categories = ({
  setFilteredProducts,
  selectedCategory,
  setSelectedCategory,
  dropdownValue,
  activeMenu,
  setActiveMenu,
  setDropdownValue,
  filteredProducts,
  productsVersion,
  user,
  setOpenAddProductModal,
  setOpenLoginModal,
  setSelectedProduct,
  setOpenEditProductModal,
  setOpenImageModal,
  setOpenUpdateImageModal,
}) => {
  const category = useParams();
  const { name, subCategories } = selectedCategory;
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const cacheRef = useRef({});
  const lastVersionRef = useRef(productsVersion);

  const { tree } = useCategoriesTree();
  useEffect(() => {
    const slug = category?.categorie;
    if (!slug) return;
    // Re-shape même si slug === selectedCategory.slug : la sidebar set
    // selectedCategory au noeud brut du tree (sans subCategories/subCat),
    // donc on doit toujours appliquer le shim ici.
    if (selectedCategory?.slug === slug && selectedCategory?.subCategories) return;
    const match = tree.find((c) => c.slug === slug);
    if (!match) return;
    const iconJsx = (node, size) =>
      node.icon
        ? renderCategoryIcon(node.icon, node.iconColor || "white", size, node.badge)
        : null;
    const visibleOnly = (nodes) =>
      (nodes || []).filter((n) => (user ? true : n.visible));
    setSelectedCategory({
      ...match,
      icon: iconJsx(match, "4x"),
      subCategories: visibleOnly(match.children).map((ch) => ({
        ...ch,
        icon: iconJsx(ch, "3x"),
        subCat: visibleOnly(ch.children).map((g) => ({
          ...g,
          icon: iconJsx(g, "2x"),
        })),
      })),
    });
    setActiveMenu("");
    setDropdownValue("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category?.categorie, tree, selectedCategory, user]);

  // Cherche le subCat correspondant à dropdownValue dans n'importe quelle subCategory
  // (anciennement hardcodé sur les index [0]/[1]/[3] — fragile avec l'admin reorder).
  const result =
    (selectedCategory.slug === "vins" || selectedCategory.slug === "alcools") &&
    (selectedCategory?.subCategories || [])
      .flatMap((sc) => sc.subCat || [])
      .find((g) => g.slug === dropdownValue);
  const prevDropdownValueRef = useRef();

  useEffect(() => {
    prevDropdownValueRef.current = dropdownValue;
  });

  const prevDropdownValue = prevDropdownValueRef.current;

  useEffect(() => {
    const type = selectedCategory?.slug;
    if (!type) return;
    const lang = (navigator.language || "fr").toLowerCase().slice(0, 2);
    const cacheKey = `${type}_${lang}`;

    if (productsVersion !== lastVersionRef.current) {
      cacheRef.current = {};
      lastVersionRef.current = productsVersion;
    } else if (cacheRef.current[cacheKey]) {
      setProducts(cacheRef.current[cacheKey]);
      return;
    }

    setLoading(true);
    axios
      .get(`${$SERVER}/api/products`, { params: { type, lang } })
      .then((res) => {
        const data = res.data.data || [];
        cacheRef.current[cacheKey] = data;
        setProducts(data);
      })
      .catch((err) => console.error("fetch products error", err))
      .finally(() => setLoading(false));
  }, [selectedCategory, productsVersion]);

  useEffect(() => {
    if (activeMenu || dropdownValue) return;
    if (!products?.length) return;
    const subs = selectedCategory?.subCategories || [];
    if (!subs.length) return;
    const subsWithProducts = subs.filter((ch) =>
      products.some((p) => p.category === ch.slug),
    );
    if (!subsWithProducts.length) return;
    const def =
      subsWithProducts.find(
        (ch) => ch.slug === selectedCategory.defaultChildSlug,
      ) || subsWithProducts[0];
    setActiveMenu(def.slug);
    if (def.defaultChildSlug) {
      const defGrand = (def.subCat || []).find(
        (g) =>
          g.slug === def.defaultChildSlug &&
          products.some((p) => p.subCategory === g.slug),
      );
      if (defGrand) setDropdownValue(defGrand.slug);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, selectedCategory]);

  useEffect(() => {
    if (!products?.length) {
      setFilteredProducts([]);
      return;
    }
    if (dropdownValue) {
      setFilteredProducts(
        products.filter((p) => p.subCategory === dropdownValue),
      );
    } else if (activeMenu) {
      setFilteredProducts(products.filter((p) => p.category === activeMenu));
    } else {
      setFilteredProducts(products);
    }
  }, [products, activeMenu, dropdownValue]);

  const token = localStorage.getItem("token-1755");

  const handleDeleteProduct = (productId) => {
    if (token) {
      setLoading(true);
      axios({
        method: "delete",
        url: `${$SERVER}/api/products/deleteProduct`,
        data: {
          productId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          const filtered = response.data.data.filter(
            (p) => p.type === selectedCategory.slug,
          );
          setProducts(filtered);
          const cacheKey = `${selectedCategory.slug}_${(
            navigator.language || "fr"
          )
            .toLowerCase()
            .slice(0, 2)}`;
          cacheRef.current[cacheKey] = filtered;
        })
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));
    } else {
      setOpenLoginModal(true);
    }
  };

  const handleChangeVisibility = (product) => {
    let { image, ...newProduct } = product;
    newProduct.visible = !product.visible;
    if (token) {
      setLoading(true);
      axios({
        method: "post",
        url: `${$SERVER}/api/products/updateProduct`,
        data: {
          update: newProduct,
          productId: product._id,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          const filtered = response.data.data.filter(
            (p) => p.type === selectedCategory.slug,
          );
          setProducts(filtered);
          const cacheKey = `${selectedCategory.slug}_${(
            navigator.language || "fr"
          )
            .toLowerCase()
            .slice(0, 2)}`;
          cacheRef.current[cacheKey] = filtered;
        })
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));
    } else {
      setOpenLoginModal(true);
    }
  };

  const handleChangeChoice = (product) => {
    let { image, ...newProduct } = product;
    newProduct.choice = !product.choice;
    if (token) {
      setLoading(true);
      axios({
        method: "post",
        url: `${$SERVER}/api/products/updateProduct`,
        data: {
          update: newProduct,
          productId: product._id,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          const filtered = response.data.data.filter(
            (p) => p.type === selectedCategory.slug,
          );
          setProducts(filtered);
          const cacheKey = `${selectedCategory.slug}_${(
            navigator.language || "fr"
          )
            .toLowerCase()
            .slice(0, 2)}`;
          cacheRef.current[cacheKey] = filtered;
        })
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));
    } else {
      setOpenLoginModal(true);
    }
  };

  return (
    <Container className="categories">
      {user && (
        <div>
          <Button
            color="green"
            circular
            size="medium"
            onClick={() => setOpenAddProductModal(true)}
          >
            <FontAwesomeIcon icon={faPlus} size="2x" />
          </Button>
        </div>
      )}
      <Header
        className="categories-header"
        as="h2"
        style={
          activeMenu.includes("rouge") || dropdownValue?.includes("rouge")
            ? { color: "darkred" }
            : activeMenu.includes("rose") || dropdownValue?.includes("rose")
              ? { color: "#fec5d9" }
              : activeMenu.includes("blanc") || dropdownValue?.includes("blanc")
                ? { color: "#f1f285" }
                : { color: "white" }
        }
      >
        {selectedCategory.name}
        {(category.categorie === "vins" || category.categorie === "alcools") &&
          !!dropdownValue && (
            <Transition
              visible={dropdownValue === prevDropdownValue}
              animation="fly right"
              duration={1000}
            >
              <Header.Subheader className="categories-subheader">
                {result?.name || ""}
              </Header.Subheader>
            </Transition>
          )}
      </Header>
      <Divider hidden />
      {subCategories?.length > 0 && (
        <ProductsFilteringMenu
          products={products}
          dropdownValue={dropdownValue}
          subCategories={subCategories}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          setDropdownValue={setDropdownValue}
        />
      )}
      <Divider hidden />
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 5000,
          }}
        >
          <Loader />
        </div>
      )}
      <div className="products">
        {!loading &&
          filteredProducts
            ?.sort((a, b) => a.price - b.price)
            .map((p) => (
              <React.Fragment key={p._id}>
                {user && (
                  <AdminCrudButtons
                    loading={loading}
                    {...p}
                    product={p}
                    handleDeleteProduct={handleDeleteProduct}
                    handleChangeVisibility={handleChangeVisibility}
                    handleChangeChoice={handleChangeChoice}
                    setSelectedProduct={setSelectedProduct}
                    setOpenEditProductModal={setOpenEditProductModal}
                    setOpenUpdateImageModal={setOpenUpdateImageModal}
                  />
                )}
                <ProductItem
                  product={p}
                  {...p}
                  user={user}
                  setOpenImageModal={setOpenImageModal}
                  setSelectedProduct={setSelectedProduct}
                />
              </React.Fragment>
            ))}
      </div>
      <Divider hidden />
      {subCategories?.length > 0 && filteredProducts.length > 1 && (
        <ProductsFilteringMenu
          products={products}
          dropdownValue={dropdownValue}
          subCategories={subCategories}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          setDropdownValue={setDropdownValue}
        />
      )}
    </Container>
  );
};

export default Categories;
